import React from "react";
import Sidebar from "./Sidebar";

export default function IncidentReport() {
    return (
        <div>
            <Sidebar />
            <h1>Incident Report</h1>
        </div>
    );
}